import { render, staticRenderFns } from "./OfferProcedureDialog.vue?vue&type=template&id=980c8c02&scoped=true"
import script from "./OfferProcedureDialog.vue?vue&type=script&lang=js"
export * from "./OfferProcedureDialog.vue?vue&type=script&lang=js"
import style0 from "./OfferProcedureDialog.vue?vue&type=style&index=0&id=980c8c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980c8c02",
  null
  
)

export default component.exports